import { render, staticRenderFns } from "./HomeProjects.vue?vue&type=template&id=6e9556ea&scoped=true&"
import script from "./HomeProjects.vue?vue&type=script&lang=js&"
export * from "./HomeProjects.vue?vue&type=script&lang=js&"
import style0 from "./HomeProjects.vue?vue&type=style&index=0&id=6e9556ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9556ea",
  null
  
)

export default component.exports